import React from 'react'
import classNames from "classnames";
import { withNamespaces } from "react-i18next";
import Swal from 'sweetalert2'
import PropTypes from "prop-types";

// Open Layers
import OlSourceTileWMS from "ol/source/TileWMS";
import OlSourceVector from "ol/source/Vector";
import OlLayerTile from "ol/layer/Tile";
import OlLayerVector from "ol/layer/Vector";
import OlFormatGeoJSON from 'ol/format/GeoJSON';
import { bbox as OlBBoxStrategy } from 'ol/loadingstrategy'

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Button from "components/CustomButtons/Button.jsx";
import IconButton from '@material-ui/core/IconButton';
import Icon from "@material-ui/core/Icon";
import Popper from "@material-ui/core/Popper";
import Paper from "@material-ui/core/Paper";
import Grow from "@material-ui/core/Grow";
import Divider from "@material-ui/core/Divider";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import MenuItem from "@material-ui/core/MenuItem";
import MenuList from "@material-ui/core/MenuList";
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';

import mapStyle from "assets/jss/prehnit/components/mapStyle.jsx";

import { API } from "services/api"

class BaseLayerSwitcher extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false
    }

    this.userBaseLayers = [];

    this.handleClick = this.handleClick.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleAdd = this.handleAdd.bind(this);
    this.handleCloseMenu = this.handleCloseMenu.bind(this);
    this.handleDeleteMenuItem = this.handleDeleteMenuItem.bind(this);
  }

  handleClick = () => {
    this.setState(state => ({
      open: !state.open,
    }));
  };

  handleClose = event => {
    if (this.anchorEl.contains(event.target)) {
      return;
    }
    this.setState({ open: false });
  };

  handleAdd = event => {
    const { t, classes } = this.props;

    let layerOptions = [];

    Swal.mixin({
      confirmButtonText: t("common:next"),
      confirmButtonColor: "#7fc142",
      showCancelButton: true,
      cancelButtonText: t("common:cancel"),
      cancelButtonColor: "#f44336",
      reverseButtons: true,
      customClass: {
        title: classes.alertTitle,
        confirmButton: classNames(classes.button, classes.primary),
        cancelButton: classNames(classes.button, classes.danger)
      },
      progressSteps: ['1', '2', '3']
    }).queue([
      {
        title: t("map:basemap-wizz-url-title"),
        input: 'text',
        inputPlaceholder: t("map:basemap-wizz-url-desc"),
        validationMessage: t("common:required-input"),
        preConfirm: function (url) {
          url = url.toLowerCase();
          const ind0 = url.indexOf('http://');
          const ind1 = url.indexOf('https://');
          if (url === '') {
            Swal.showValidationMessage(t("common:required-input"));
          } else if (ind0 !== 0 && ind1 !== 0) {
            Swal.showValidationMessage("Invalid url");
          } else {
            return API.getExternalGeoLayers(url)
              .then(data => {
                if (data) {
                  data.forEach(function (obj) {
                    layerOptions.push(obj['name']);
                  })
                } else {
                  throw new Error('error msg')
                }
              })
              .catch(err => {
                console.error('Error catching layer names from external GIS server:', err);
                Swal.showValidationMessage(err);
              })
          }
        }.bind(this)
      },
      {
        title: t("map:basemap-wizz-layer-title"),
        input: 'select',
        inputOptions: layerOptions,
        inputPlaceholder: t("map:basemap-wizz-layer-desc"),
        preConfirm: function (ind) {
          if (!ind) {
            Swal.showValidationMessage(t("common:required-input"));
          } else {
            return Promise.resolve();
          }
        }
      },
      {
        title: t("map:basemap-wizz-name-title"),
        input: 'text',
        inputPlaceholder: t("map:basemap-wizz-name-desc"),
        preConfirm: function (name) {
          if (!name) {
            Swal.showValidationMessage(t("common:required-input"));
          } else {
            return Promise.resolve();
          }

        }
      }
    ]).then((result) => {
      if (result.value && result.value.length === 3) {

        let url = result.value[0];
        let layerName = layerOptions[result.value[1]];
        let name = result.value[2];

        if (this.props.onAdd) {
          const layer = this.generateLayer(url, layerName, name);
          this.props.onAdd(layer);
        }

        Swal.fire({
          title: t("map:basemap-added"),
          type: 'success',
          confirmButtonText: t("common:ok"),
          confirmButtonColor: "#7fc142",
          customClass: {
            confirmButton: classNames(classes.button, classes.primary)
          }

        })
      }
    })
  };

  handleCloseMenu(param) {
    this.setState({
      open: false,
      selectedLayerId: param.id,
      selectedLayerName: param.layer
    });
    if (this.props && this.props.onSelect) {
      this.props.onSelect(param);
    }
  };

  handleDeleteMenuItem(param) {
    this.setState({
      open: false
    });
    if (this.props && this.props.onRemove) {
      this.props.onRemove(param);
    }
  }

  guessType(url) {
    url = url.toLowerCase();
    let ind = url.indexOf('wfs');
    if (ind > 0) {
      return 'wfs'
    } else {
      return 'wms';
    }
  }

  generateLayer(url, layer, name) {

    const layers = this.props.userLayersList;

    let id = 1000;
    if (layers && layers.length > 0) {
      let ids = layers.map(x => x.id);
      let maxId = Math.max(...ids);
      id = maxId + 1;
    }

    let type = this.guessType(url);

    if (type == 'wfs') {
      var serverUrl = url.indexOf('?') > 0 ? url.substring(0,url.indexOf('?')) : url
      let vectorSource = new OlSourceVector({
        format: new OlFormatGeoJSON(),
        url: function (extent, resolution, projection) {
          var proj = projection.getCode();
          var wfsurl = serverUrl + '?service=WFS' + '&' +
            'version=1.1.0&request=GetFeature&typename=' + layer + '&' +
            'outputFormat=application/json&srsname=' + proj;
          if (extent && extent.length === 4 && isFinite(extent[0]) && isFinite(extent[1]) && isFinite(extent[2]) && isFinite(extent[3])) {
            wfsurl = wfsurl + '&bbox=' + extent.join(',') + ',' + proj;
          }
          let apiUrl = process.env.REACT_APP_API_Url + '/externalgeo/features?url=' + encodeURIComponent(wfsurl);
          return apiUrl;
        },
        strategy: OlBBoxStrategy
      });

      return {
        id: id,
        display: name,
        layer: new OlLayerVector({
          source: vectorSource
        })
      }

    } else { //wms
      return {
        id: id,
        display: name,
        layer: new OlLayerTile({
          source: new OlSourceTileWMS({
            url: url,
            params: { 'Layers': layer },
            projection: 'EPSG:3857'
          })
        })
      }

    }
  }

  render() {
    const { t, classes,
      buttonText, buttonIcon,
      hoverColor, noLiPadding, systemLayersList, userLayersList, dropup, navDropdown
    } = this.props;
    const { open } = this.state;


    const dropdownItem = classNames({
      [classes.dropdownItem]: true,
      [classes[hoverColor + "Hover"]]: true,
      [classes.noLiPadding]: noLiPadding
    });

    const menu = (
      <MenuList role="menu" className={classes.menuList}>
        {systemLayersList.map((prop, key) => {
          return (
            <MenuItem
              key={key}
              onClick={() => this.handleCloseMenu(prop)}
              className={dropdownItem}
            >
              <Icon className={classes.dropdownIcons}>{prop.icon ? prop.icon : "layers"}</Icon>
              {prop.displayCode ? t(prop.displayCode) : prop.display}
            </MenuItem>
          );
        })}
        {userLayersList && userLayersList.length > 0 ?
          <Divider
            key="999"
            onClick={() => this.handleCloseMenu("divider")}
            className={classes.dropdownDividerItem}
          /> : null}
        {userLayersList.map((prop, key) => {
          return (
            <MenuItem
              key={key}
              onClick={() => this.handleCloseMenu(prop)}
              className={dropdownItem}
            >
              <Icon className={classes.dropdownIcons}>{prop.icon ? prop.icon : "layers"}</Icon>
              {prop.displayCode ? t(prop.displayCode) : prop.display}
              <ListItemSecondaryAction>
                <IconButton aria-label="Delete" className={classes.secondaryActionButton} onClick={() => this.handleDeleteMenuItem(prop)}>
                  <Icon className={classes.secondaryActionButtonIcon}>delete</Icon>
                </IconButton>
              </ListItemSecondaryAction>
            </MenuItem>
          );
        })}

        <Divider
          key="998"
          onClick={() => this.handleCloseMenu("divider")}
          className={classes.dropdownDividerItem}
        />
        <MenuItem
          key="1001"
          onClick={() => this.handleAdd()}
          className={dropdownItem}
        >
          <Icon className={classes.dropdownIcons}>add</Icon>
          {t("map:basemap-add")}
        </MenuItem>
      </MenuList>
    );

    return (
      <div className={classes.manager}>
        <div className={classNames(buttonText !== undefined ? "" : classes.target)}>
          <Button
            aria-label="Base Layers"
            aria-owns={open ? "menu-list-baselayers" : null}
            aria-haspopup="true"
            buttonRef={node => {
              this.anchorEl = node;
            }}
            color="primary"
            onClick={this.handleClick}
            className={classes.smallButton}
          >
            <Icon className={classes.smallButtonIcon}>{buttonIcon}</Icon>
          </Button>

          <Popper
            open={open}
            anchorEl={this.anchorEl}
            transition
            disablePortal
            placement="bottom"
            className={classNames({
              [classes.popperClose]: !open,
              [classes.pooperResponsive]: true,
              [classes.pooperNav]: open && navDropdown
            })}
          >
            {({ TransitionProps, placement }) => (
              <Grow
                in={open}
                id="menu-list-baselayers"
                style={
                  dropup
                    ? { transformOrigin: "0 100% 0" }
                    : { transformOrigin: "0 0 0" }
                }
              >
                <Paper className={classes.dropdown}>
                  <ClickAwayListener onClickAway={this.handleClose} ref="cacat">
                    {menu}
                  </ClickAwayListener>
                </Paper>
              </Grow>
            )}
          </Popper>

        </div>
      </div>
    );
  }
}

BaseLayerSwitcher.defaultProps = {
  dropup: false,
  hoverColor: "primary",
  buttonIcon: "layers",
  buttonProps: {
    round: false,
    block: true,
    color: "primary"
  },
};

BaseLayerSwitcher.propTypes = {
  classes: PropTypes.object.isRequired,
  hoverColor: PropTypes.oneOf([
    "dark",
    "primary",
    "info",
    "success",
    "warning",
    "danger",
    "rose"
  ]),
  buttonText: PropTypes.node,
  buttonIcon: PropTypes.string,
  layersList: PropTypes.array,
  buttonProps: PropTypes.object,
  dropup: PropTypes.bool,
  dropdownHeader: PropTypes.node,
  rtlActive: PropTypes.bool,
  caret: PropTypes.bool,
  dropPlacement: PropTypes.oneOf([
    "bottom",
    "top",
    "right",
    "left",
    "bottom-start",
    "bottom-end",
    "top-start",
    "top-end",
    "right-start",
    "right-end",
    "left-start",
    "left-end"
  ]),
  noLiPadding: PropTypes.bool,
  innerDropDown: PropTypes.bool,
  navDropdown: PropTypes.bool,
  // This is a function that returns the clicked menu item
  onClick: PropTypes.func
};

export default withNamespaces()(withStyles(mapStyle)(BaseLayerSwitcher));